/*
 * @Author: WangChao
 * @Date: 2026-02-06 11:41:52
 * @LastEditors: WangChao
 * @LastEditTime: 2026-08-26 11:13:22
 * @FilePath: \travel_ai\src\main.js
 * @Description:
 */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import { logInfo } from "./definition/conf/index.js";
logInfo();
import "@babel/polyfill";
import Vue from "vue";
import App from "./App";
import router from "./router";
import "normalize.css";
import "animate.css/animate.min.css";
import { LOG, APPS, BACKEND } from "./config/SETUP";
import Logger from "yn-p1/libs/modules/log/logger";
import YnP1 from "yn-p1";

// 自定义flat(解决低版本兼容)
import { flatArray } from "yn-smartq/libs/utils/tool";
// 不能被 for in 循环遍历
Object.defineProperty(Array.prototype, "flat", {
  enumerable: false,
  value: flatArray
});

/**** 引入yn-smartq组件库字体****/
import "yn-smartq/libs/assets/iconfont/iconfont.css";

if (window.YN_ZHIDA.theme === "stateGrid") {
  import("@/less/stateGrid/theme.less");
  import("@/less/stateGrid/custom.less"); // 自定义国网主题的packages组件样式
  import("@/less/stateGrid/common.less");
  import("@/less/stateGrid/mobile_app.less");
} else {
  import("yn-smartq/libs/style/index.less");
  import("@/less/yuanian/theme.less");
  import("@/less/yuanian/common.less");
  import("@/less/yuanian/mobile_app.less");
}

// 文本气泡卡片支持复制
if (window.YN_ZHIDA.supportTextCopy) {
  import("@/less/custom.less");
}

// 外部jssdk集成工具
if (window.YN_ZHIDA.isShare) {
  import("@/utils/shareSdk/share");
}

import store from "./store";
// const Conf = require('@/definition/conf')
// const sessionStore = require('@/lib/sessionStorage')['default']
// const G = require('@/definition/g')
import VueI18n from "vue-i18n";
Vue.use(VueI18n);
import Antd, { message } from "ant-design-vue";
import "ant-design-vue/dist/antd.css";
Vue.use(Antd);
Vue.prototype.$message = message;
const i18n = new VueI18n({
  locale: "zh-CN",
  messages: {
    "zh-CN": require("@/definition/locale/zh-CN.js"),
    en: require("@/definition/locale/en.js")
  }
});
// YN组件库
Logger.option("level", LOG.LEVEL);
Logger.warn(
  `Platform Log Level: ${
    LOG.LEVEL === 2
      ? "2 - Warn"
      : LOG.LEVEL === 3
      ? "3 - Info"
      : LOG.LEVEL === 4
      ? "4 - Log"
      : ""
  }`
);
YnP1.setup(LOG, APPS, BACKEND);

// import * as ynComponentsTransfer from "@/lib/ynComponentsTransfer";
// Vue.use(ynComponentsTransfer);
import VueAmap2x from "vue-amap2.x";
Vue.use(VueAmap2x);

import Pmessage from "@/lib/pmessage";
Vue.use(Pmessage);

Vue.config.productionTip = false;
/* eslint-disable no-new */
window.VueInstance = new Vue({
  store,
  router,
  i18n,
  render: (h) => h(App)
}).$mount("#app");
